import { ViewProductSchema } from '@app/models/products';

export const searchProducts = (products: ViewProductSchema[], query: string): ViewProductSchema[] => {
  const normalizedQuery = query.trim().toLowerCase();

  if (!normalizedQuery) return products;

  return products.filter((product) => {
    const fields: (string | null | undefined)[] = [
      product.title,
      product.code,
      product.description,
      product.brand?.title,
      product.category?.title,
      ...product.tags.map((tag) => tag.title),
    ];

    return fields
      .filter((value): value is string => typeof value === 'string')
      .some((value) => value.toLowerCase().includes(normalizedQuery));
  });
};
